<div class="diary-widget-bar">
  <ul>
    <li class="prev">
      <button class="diary-navigator-button prev" (click)="prevChevronClicked()" pButton icon="fa-fw fa fa-caret-left fa-2x"></button>
    </li>
    <li class="title">
      <button class="diary-navigator-title" (click)="titleBarClicked()" pButton [label]="getTitle()"></button>
    </li>
    <li class="next">
      <button class="diary-navigator-button next" (click)="nextChevronClicked()" pButton icon="fa-fw fa fa-caret-right fa-2x"></button>
    </li>

  </ul>
</div>
